import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { useUniqueID } from '../../hooks/useUniqueID.js';
import classnames from 'classnames';

const Loading = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    className = '',
    size,
    ...rest
  } = _ref;
  const titleId = useUniqueID();
  const descId = useUniqueID();
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: size,
    height: size,
    fill: "none",
    "data-testid": "loading",
    ref: ref,
    className: classnames(className, 'b-loading', 'b-loading__spin'),
    role: "img",
    "aria-hidden": "false",
    "aria-labelledby": `${titleId} ${descId}`
  }, rest), /*#__PURE__*/React__default.createElement("title", {
    id: titleId
  }, "Loading"), /*#__PURE__*/React__default.createElement("desc", {
    id: descId
  }, "A loading spinner animation"), /*#__PURE__*/React__default.createElement("path", {
    d: "M64 32a32 32 0 1 0-47.416 28.042l3.854-7.01A24 24 0 1 1 56 32h8Z"
  }));
});
Loading.displayName = 'Loading';

export { Loading };
